module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-range"
  }, [_c('h2', [_vm._v("Extend time")]), _c('p', [_vm._v("Set up the marker to change time")]), _c('div', {
    staticClass: "rect-list"
  }, [_vm._m(0), _vm._l((_vm.availability), function(item, index) {
    return _c('div', {
      staticClass: "rect",
      class: {
        available: item.available, reservation: _vm.isInReservation(index)
      },
      on: {
        "click": function($event) {
          return _vm.onClick(index)
        }
      }
    }, [(index % 3 == 0) ? _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.formatDate(item.end)))]) : _vm._e()])
  })], 2), (_vm.debug.selectedEnd) ? _c('h3', [_vm._v("Extend this reservation to " + _vm._s(_vm.debug.selectedEnd))]) : _vm._e(), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("Confirm Extension")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f427b69e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/extend-reservation/TimeRange.vue
// module id = 2673
// module chunks = 1